import axios from 'axios'
import externalComponent from '../utils/external-component';
import VueMixinTween from 'vue-mixin-tween';
import {
    Navbar,
    NavLink
} from '@/components';
import {
    mapState
} from 'vuex'
import onPublishMessageSub from "@/graphql/onPublishMessage"
import pingAPIQuery from "@/graphql/pingAPIQuery";
export default {
    name: 'main-navbar',
    mounted() {
        var w = this;
        setTimeout(() => {
            this.isActive = true;
        }, 500)
    },
    data() {
        return {
            spinner: false,
            error: false,
            lastSubAttempt: Date.now(),
            isActive: false,
            subscriptions: {},
            credits: this.$store.getters.get('credits'),
            modals: {
                classic: false
            },
            signedIn: false,
            username: null,
            usermail: null,
            to: this.$route && this.$route.query && this.$route.query.to ? this.$route.query.to : false
        }
    },
    computed: {
        ...mapState({
            lastQuery: 'lastQuery',
            cbloaded: 'cbInstance',
            onLine: 'onLine',
            slider: 'slider',
            subId: 'subId',
            statusMessage: 'statusMessage',
            subscription: 'subscription',
            lastUpdate: 'lastUpdate',
            userUpdated: 'userUpdated',
            graphQLurl: 'graphQLurl',
            subsActive: 'subsActive'
        }),
        subscriptionStatus: function() {
            if (this.onLine) {
                this.reconnect()
                return true
            } else {
                this.disconnect()
                return false
            }
        }
    },
    beforeCreate() {
        this.$eventBus.$on('spinner', info => {
            if (info === 'run') {
                this.spinner = true;
            } else {
                this.spinner = false;
            }
        });
        this.$eventBus.$on('authState', info => {
            if (info === 'forceLogin' || info === 'signUp' || info === 'signIn' || info === 'confirmSignUp') {
                this.$modal.show('login');
            }
            if (info === 'signedIn') {
                // first login
                this.subscriptions = {};
                this.to = this.$store.getters.get('target') ? this.$store.getters.get('target') : "/home"
                var init = this.$store.getters.get('init')
                this.$store.replaceState(JSON.parse(init));
                this.$store.commit('change', {
                    init: init
                });
                this.signedIn = true;
                this.$modal.hide('login');
                this.$auth.currentAuthenticatedUser()
                    .then(user => {
                        this.$store.commit('change', {
                            user: {
                                username: user.username
                            }
                        });
                        this.username = user.username;
                        this.usermail = user.attributes.email;
                        if (this.to) this.$router.push(this.to);
                        this.$store.commit('change', {
                            target: false
                        });
                        this.pubsub('itility:user:' + user.username, 0);
                        this.pubsub('itility:broadcast', 0);
                        if (this.$store.getters.get('env') !== 'production') this.pubsub('itility:broadcast:staging', 0);
                        //this.getUser(this.username);
                    })
                    .catch(() => {
                        this.username = null;
                        this.$store.commit('change', {
                            user: false
                        });
                        this.to = this.$route && this.$route.query && this.$route.query.to ? this.$route.query.to : false
                        if (this.to) this.$modal.show('login');
                    })
            }
            if (info === 'signedOut') {
                this.signedIn = false,
                    this.subscriptions = {};
                this.username = null;
                this.$store.commit('change', {
                    user: false
                });
                this.$router.push('/')
            }
        });
        this.$auth.currentAuthenticatedUser()
            .then(user => {
                this.username = user.username;
                this.usermail = user.attributes.email;
                this.signedIn = true
                this.pubsub('itility:user:' + user.username, 0);
                this.pubsub('itility:broadcast', 0);
                if (this.$store.getters.get('env') !== 'production') this.pubsub('itility:broadcast:staging', 0);
                this.$modal.hide('login');
                this.$store.commit('change', {
                    user: {
                        username: user.username
                    }
                });
                //this.getUser(this.username);
            })
            .catch((err) => {
                console.log('Not authenticated', err);
                this.to = this.$route && this.$route.query && this.$route.query.to ? this.$route.query.to : false
                if (this.to) this.$modal.show('login');
            })
    },
    created() {
        var w = this;
        this.$eventBus.$on('appEvents', info => {
            if (typeof(info) === 'object' && info.component === 'nav') {
                var exec = info.exec;
                try {
                    this[exec](info.params)
                } catch (err) {
                    console.log('error: ', err)
                }
            } else {
                if (typeof(info) === 'object' && info.exec === 'refreshCache') {
                    localStorage.setItem('cacheVer', info.params)
                }
            }
        })
    },
    props: {
        transparent: Boolean,
        colorOnScroll: Number,
    },
    components: {
        Navbar,
        NavLink,
        //GenoLogo
    },
    mixins: [
        VueMixinTween('credits', 100, (pos) => pos)
    ],
    methods: {
        setStatusMessage: function(params) {
            if (params.message && params.id && params.id === this.subId) {
                this.$store.commit('change', {
                    fadeIn: false
                });
                this.$store.commit('change', {
                    statusMessage: params.message
                });
                setTimeout(() => {
                    this.$store.commit('change', {
                        fadeIn: true
                    });
                }, 500)
            }
        },
        clearError: function() {
            this.error = false;
        },
        GetFormattedDate: function() {
            var format = function(str) {
                var str = "0" + str;
                var l = str.length;
                return (str.substring(l - 2, l))
            }
            var todayTime = new Date();
            var month = format(todayTime.getMonth() + 0);
            var day = format(todayTime.getDate());
            var year = (todayTime.getFullYear());
            //return month + "/" + day + "/" + year;
            return year + "-" + month + "-" + day;

        },
        show: function(params) {
            var w = this;
            var title = params.title ? params.title : 'Alert!'
            var text = params.text ? params.text : 'Message received...'
            var button = params.button ? params.button : 'OK'
            var buttons = [{
                title: button,
                default: true, // Will be triggered by default if 'Enter' pressed.
            }]
            if (params.closed && params.closed === 'clearError') {
                buttons.unshift({
                    title: 'Clear Error',
                    handler: () => {
                        if (params.closed) w[params.closed]();
                        this.$modal.hide('dialog')
                    } // Button click handler
                })
            }
            if (params.action && typeof(params.action) === 'object' && params.action.button && params.action.method) {
                var action = params.action
                buttons.unshift({
                    title: action.button,
                    handler: () => {
                        this[action.method](action.params)
                    }
                })
            }
            this.$modal.show('dialog', {
                title: title,
                text: text,
                class: params.class ? params.class : undefined,
                buttons: buttons,
                beforeClose: function(event) {
                    console.log('closed ', event)
                }
            })
        },
        refreshPage: function() {
            window.location.reload(true)
        },
        reconnect: function() {
            var w = this;
            if (this.subscriptions && Object.keys(this.subscriptions) && Object.keys(this.subscriptions).length > 0) {
                this.lastSubAttempt = Date.now()
                var subs = Object.keys(this.subscriptions);
                console.log('active subscriptions ', subs);
                var resub = function() {
                    subs.forEach(id => {
                        console.log('reconnecting subscription: ' + id)
                        w.pubsub(id, 0);
                    });
                }
                console.log('verifying graphQL endpoint...');
                var retrying = 0;
                var pingUrl = function() {
                    setTimeout(() => {
                        w.$apollo.query({
                                query: pingAPIQuery,
                                context: {
                                    timeout: 3000
                                },
                                fetchPolicy: 'network-only'
                            })
                            .then(data => {
                                resub();
                            }).catch(err => {
                                w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                                retrying = retrying === 0 ? 1000 : 5000;
                                pingUrl();
                            })
                    }, retrying)
                }
                pingUrl();
            }
        },
        disconnect: function() {
            if (this.subscriptions && Object.keys(this.subscriptions) && Object.keys(this.subscriptions).length > 0) {
                this.$store.commit('change', {
                    subsActive: false
                });
                var subs = Object.keys(this.subscriptions);
                subs.forEach(id => {
                    console.log('disconnecting subscription: ' + id)
                    this.subscriptions[id].unsubscribe();
                })
            }
        },
        execFunc(remoteFunc) {
            this.$eventBus.$emit('appEvents', remoteFunc)
        },
        getStatus: function() {
            var title = "Current Status"
            var text = ''
            if (this.onLine && this.subsActive) {
                var subs = Object.keys(this.subscriptions);
                text = '<b style="color:green">application is online</b><br/><br/>active channels:<br/><b>'
                subs.forEach(id => {
                    text = text + id + "<br/>"
                })
                text = text + "</b>"
                if (this.lastQuery) {
                    text = text + '<br/>' + this.lastQuery
                }
                if (this.error) {
                    text = text + '<br/><b style="color:brown">Error:</b> ' + this.error
                }
            } else {
                text = '<b style="color:brown" >application is offline</b><br/><br/>disonnected channels:<br/><b>'
                var subs = Object.keys(this.subscriptions);
                subs.forEach(id => {
                    text = text + id + "<br/>"
                })
                text = text + "</b>"
                if (this.lastQuery) {
                    text = text + '<br/>' + this.lastQuery
                }
                if (this.error) {
                    text = text + '<br/><b style="color:brown">Error:</b> ' + this.error
                }
            }
            this.show({
                title: title,
                text: text,
                closed: this.error ? 'clearError' : undefined
            });
        },

        pubsub: function(id, retry) {
            var w = this;
            console.log('subscribing to ' + id + ' on ' + new Date().toLocaleString());
            this.error = false;
            this.$store.commit('change', {
                subsActive: true
            });
            this.$store.commit('change', {
                onLine: true
            });
            this.subscriptions[id] = true;
            const observable = this.$apollo.subscribe({
                query: onPublishMessageSub,
                variables: {
                    id: id
                }
            });
            const executeAction = function executeAction(data) {
                if (!w.onLine) w.$store.commit('change', {
                    onLine: true
                });
                retry = retry === 0 ? 50 : retry >= 60000 ? 60000 : retry * 2;
                try {
                    if (data.data && data.data.onPublishMessage && data.data.onPublishMessage.message) {
                        var message = JSON.parse(data.data.onPublishMessage.message)
                        if (message.action && message.component) {
                            w.$eventBus.$emit('appEvents', {
                                exec: message.action,
                                component: message.component,
                                params: message.params ? message.params : undefined
                            })
                        }
                    } else {
                        w.error = message
                    }
                } catch (err) {
                    if (w.onLine) w.$store.commit('change', {
                        onLine: false
                    });
                    w.$store.commit('change', {
                        subsActive: false
                    });
                    w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                }
            }

            this.subscriptions[id] = observable.subscribe({
                next: executeAction,
                complete: console.log,
                connect: function(evt) {
                    console.log('connected ', evt)
                },
                error: function(err) {
                    console.log('subscription error: ', err)
                    w.error = err.info && err.message ? err.info + err.message : err.message ? err.message : err
                    w.reconnect()
                }
            })
        },
        showProfile: function() {
            this.$auth.currentAuthenticatedUser()
                .then(user => {
                    this.$store.commit('change', {
                        user: {
                            username: username
                        }
                    });
                    this.$modal.show('login')
                })
                .catch(() => {})
        },
        signOut: function(event) {
            this.$auth.signOut()
                .then(() => {
                    this.$router.push('/')
                    this.to = false;
                    this.username = null;
                    this.usermail = null;
                    this.$store.commit('change', {
                        user: false
                    });
                    return this.$eventBus.$emit('authState', 'signedOut')
                })
                .catch(e => this.setError(e));
        },
        setError: function(e) {
            this.error = this.$Amplify.I18n.get(e.message || e);
        },
    }
}
